import React from 'react'

import { useQuery } from '@apollo/client'
import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      onQueryError // via withQueryResults
    } = props

    // react hooks
    const { loading, data } = useQuery(query, {
      onError: onQueryError
    })

    // GraphQL data
    const { viewer, states, text, countries } = data || {}
    const parent = viewer ? viewer.user : null

    return (
      <WrappedComponent
        queryLoading={loading}
        parent={parent}
        states={states}
        countries={countries}
        text={text}
        {...props}
      />
    )
  }
}

export default withQuery
